import {
  TKwikUIInputPasswordSize,
  VKwikUIInputPasswordSize
} from "./input-password.definitions";

export const isValidKeyValue = (key: string, value: any): boolean => {
  const isBoolean = (x: boolean) => typeof x === "boolean";
  const isString = (x: string) => typeof x === "string";

  const methods = {
    disabled: isBoolean,
    focus: isBoolean,
    formControlName: isString,
    hintContent: isString,
    icon: isString,
    id: isString,
    invalid: isBoolean,
    isShowLabelOutside: isBoolean,
    label: isString,
    placeholder: isString,
    postfix: isString,
    prefix: isString,
    size: (x: TKwikUIInputPasswordSize) => VKwikUIInputPasswordSize.includes(x)
  };

  return methods[key] && methods[key](value);
};
